import Components from "./components";
const ComponentsPlugin = {
    install(app) {
        for (const [name, component] of Object.entries(Components)) {
            app.component(name, component);
        }
    }
};
export default ComponentsPlugin;
